import React, { useState, useEffect, useContext } from 'react';
import MovieCard from '../components/MovieCard';
import './HomePage.css';
import axios from 'axios';
import UserHistoryContext from '../context/UserHistoryContext';

function RecommendationPage() {
  const { watchedIds, likedIds, dislikedIds, loading: historyLoading } = useContext(UserHistoryContext);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        const response = await axios.post('/api/movies/recommendations', {
          watched: watchedIds,
          liked: likedIds,
          disliked: dislikedIds,
        });
        setRecommendations(response.data.recommendations);
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    };

    if (!historyLoading) {
      fetchRecommendations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyLoading]);

  return (
    <div className="home-page">
      <div className="genre-section">
        <h1>Recommended For You</h1>
        {recommendations.length > 0 ? (
          <div className="movie-grid-wrapper">
            <div className="movie-grid wrap">
              {recommendations.map((movie) => (
                <MovieCard key={movie.movieid} movie={movie} />
              ))}
            </div>
          </div>
        ) : (
          <p className="page-loading">Watch, like, or dislike a few movies to get recommendations.</p>
        )}
      </div>
    </div>
  );
}

export default RecommendationPage;
